const normalizeProducts = (products, type) => {
  if (!products || !products.length) {
    return []
  }

  switch (type) {
    case 'shopify-graphql':
      return products.map((product) => normalizeProductGraphql(product))
    case 'nosto-recommended':
      return products.map((product) => normalizeProductNostoRecommended(product))
    case 'searchspring-recommended':
      return products.map((product) => normalizeProductSearchspringRecommended(product))
  }
}

const normalizeProductGraphql = (product) => {
  return {
    id: product.id,
    title: product.title,
    handle: product.handle,
    url: product.onlineStoreUrl,
    featuredImage: product.featuredImage?.url,
    media: product.images.nodes,
    imageAlt: product.featuredImage?.altText,
    price: product.variants?.nodes[0].price.amount,
    compareAtPrice: product.variants?.nodes[0].compareAtPrice?.amount,
    tags: product.tags,
    variants: product.variants.nodes,
    customFields: product.metafield
  }
}

const normalizeProductNostoRecommended = (product) => {
  return {
    id: product.id,
    title: product.title,
    handle: product.url.split('products/').pop(),
    url: product.url,
    featuredImage: product.featuredImage,
    media: product.media,
    altText: product.imageAlt,
    price: product.price,
    compareAtPrice: product.compareAtPrice,
    tags: product.tags,
    variants: product.variants,
    customFields: product.customFields
  }
}

const normalizeProductSearchspringRecommended = (product) => {
  // Ensure images are always arrays and filter out nulls
  const featuredImage = product.attributes?.image || product.attributes?.imageUrl || ''
  let media = product.attributes?.images

  // Convert media to array if it's not already
  if (!media) {
    media = featuredImage ? [featuredImage] : []
  } else if (!Array.isArray(media)) {
    media = [media]
  }

  // Filter out empty values and ensure we have at least the featured image
  media = media.filter(img => img && img !== '')
  if (media.length === 0 && featuredImage) {
    media = [featuredImage]
  }

  return {
    id: parseInt(product.id),
    title: product.attributes?.title || '',
    handle: product.mappings?.core?.url ? product.mappings.core.url.split('products/').pop() : '',
    url: product.mappings?.core?.url || '',
    uid: product.mappings?.core?.uid || '',
    sku: product.mappings?.core?.sku || '',
    featuredImage,
    media,
    altText: product.imageAlt || product.attributes?.title || '',
    price: product.mappings?.core?.price || 0,
    compareAtPrice: product.mappings?.core?.msrp || null,
    tags: product.attributes?.tags || [],
    variants: product.attributes?.variants ? JSON.parse(product.attributes.variants) : [],
    sizes: product.attributes?.mfield_variant_options_size || '',
    linkedColors: product.attributes?.mfield_linked_products_colour || []
  }
}

export {
  normalizeProducts
}
